import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { SaleOrderDto } from './sale-order.dto';


export class SaleOrderResponse extends GlobalResponseObject{
    data?: SaleOrderDto;

    /**
     * 
     * @param status 
     * @param intlCode 
     * @param internalMessage 
     * @param data 
     */
     constructor(status:boolean, intlCode:number, internalMessage:string, data?: SaleOrderDto){
        super(status,intlCode,internalMessage);
        this.status = status;
        this.intlCode = intlCode;
        this.internalMessage = internalMessage;
        this.data = data;
    }
}

